export enum CarrierTypeEnum {
    USPS = "USPS",
    UPS = "UPS"
}

export enum EFileAnalyzerTypeEnum {
    SSF = 'SSF',
    PSE = 'PSE',
    PLD = 'PLD'
}

export enum PriorityEnum {
    Year = 'Year',
    Quarter = 'Quarter',
    Month = 'Month',
}

export enum  SeverityEnum {
    Low = "Low",
    Medium = "Medium",
    High = "High"
}

export enum LocalStorageKeysEnum {
    UserData = "UserData"
}

export enum LengthUnitEnum {
    Inch = "in",
    Feet = "ft",
    CentiMeter = "cm",
    Meter = "m",
}

export enum ShapeEnum {
    Box,
    Custom
}

export enum ToolsEnum {
    EFileAnalyzer = "EFile Analyzer",
    RealSizeViewer = "RealSize Viewer",
    Geocoder = "Geocoder",
    UnitConverter = "Unit Converter",
    VolumetricWeight = "Volumetric Weight"
}

export enum RefImageTypeEnum {
    Default = "Default",
    Custom = "Custom"
}

export enum ConvertTypeEnum {
    Length = "Length",
    Weight = "Weight",
    Area = "Area",
    Volume = "Volume"
}

export enum UnitConverterLengthUnitEnum {
    Meter = "m",
    CentiMeter = "cm",
    Inch = "in",
    Feet = "ft",
    Yard = "yd"
}

export enum WeightUnitEnum {
    Gram = "g",
    Kilogram = "kg",
    Milligram = "mg",
    Pound = "lb",
    Ounce = "oz"
}

export enum AreaUnitEnum {
    SquareCentiMetre = "cmsquare",
    SquareMetre = "msquare",
    SquareInch = "insquare",
    SquareFeet = "ftsquare",
    SquareYard = "ydsquare"
}

export enum VolumeUnitEnum {
    CubicCentiMetre = "cmcube",
    CubicMetre = "mcube",
    CubicInch = "incube",
    CubicFeet = "ftcube",
    CubicYard = "ydcube",
    Liter = "liter"
}

export enum CarrierEnum {
    Delhivery = "Delhivery",
    Ekart = "Ekart",
    XpressBees = "XpressBees"
}

export enum ServiceEnum {
    Surface = "Surface",
    Express = "Express"
}

//#region  Auth MS

export enum AccountCategoryEnum {
    Individual = "Individual",
    LLP = "LLP",
    Company = "Company",
    SoleProprietor = "Sole Proprietor",
    Trust = "Trust"
}

export enum AccountTypeEnum {
    Partner = "Partner",
    PartnerCustomer = "PartnerCustomer",
    DirectCustomer = "DirectCustomer",
    Admin = "Admin",
    Testing = "Testing"
}

export enum AccountStatusEnum {
    Active = "Active",
    Closed = "Closed",
    Pending = "Pending",
    Suspended = "Suspended"
}

export enum AccountTrustLevelEnum {
    Blocked = 0,
    LowTrust = 1,
    BelowAverageTrust = 2,
    AverageTrust = 3,
    AboveAverageTrust = 4,
    CompletelyTrust = 5
}

export enum AccountPaymentModeEnum {
    Both = "Both",
    Prepaid = "Prepaid",
    PostPaid = "PostPaid"
}

export enum AccountSubscriptionEnum {
    Basic = "Basic",
    Pro = "Pro",
    Enterprise = "Enterprise"
}

export enum AuthUserRoleEnum {
    SuperAdmin = "SuperAdmin",
    User = "User",
    Admin = "Admin",
}

//#endregion